import * as React from 'react';

import _t from 'i18n!nls/widget';

import 'css!./__styles__/WidgetErrorMessage';

const WidgetErrorMessage = () => {
  return (
    <div className="rc-WidgetErrorMessage vertical-box align-items-absolute-center" data-testid="widget-err">
      <span className="error-text">
        {_t('This item is provided by a 3rd party developer and cannot be accessed right now.')}
      </span>
      <a className="retry-link link-button">{_t('Retry')}</a>
    </div>
  );
};

export default WidgetErrorMessage;
